import SearchIcon from '@mui/icons-material/Search';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  SearchIconBox,
  SearchIconWrapper,
  SearchInputBase,
  SearchWrapper,
} from './index.style';

const AppSearch = ({
  iconPosition = 'left',
  overlap = true,
  placeholder,

  align = 'left',
  onlyIcon = false,
  disableFocus,
  iconStyle = {
    color: 'grey',
  },
  ...rest
}) => {
  return (
    <SearchWrapper sx={rest.sx} iconPosition={iconPosition}>
      <SearchIconBox
        align={align}
        className={clsx(
          'searchRoot',
          {'hs-search': overlap},
          {'hs-disableFocus': disableFocus},
          {searchIconBox: onlyIcon},
        )}
      >
        <SearchIconWrapper
          style={iconStyle}
          className={clsx({
            left: iconPosition === 'left',
            right: iconPosition === 'right',
          })}
        >
          <SearchIcon />
        </SearchIconWrapper>
        <SearchInputBase
          {...rest}
          placeholder={placeholder || 'Search…'}
          inputProps={{'aria-label': 'search'}}
        />
      </SearchIconBox>
    </SearchWrapper>
  );
};

AppSearch.propTypes = {
  iconPosition: PropTypes.oneOf(['left', 'right']),
  overlap: PropTypes.bool,
  placeholder: PropTypes.string,

  align: PropTypes.oneOf(['left', 'right', 'center']),
  onlyIcon: PropTypes.bool,
  disableFocus: PropTypes.bool,
  iconStyle: PropTypes.object,
};

export default AppSearch;
